import './EmergingImages.scss';
import { gsap } from 'gsap';
import { wrapElement } from '../../utils/utils';

class EmergingImages {
    constructor() {
        this.DOM = { wrapper: [...document.querySelectorAll('.emerging-wrp')] }
        this.DOM.innerWrapper = [];
        this.DOM.images = [...document.querySelectorAll('.emerging-wrp img')]
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const outerWrapper = entry.target;
                    const innerWrapper = outerWrapper.querySelector('.innerWrapper');
                    const image = innerWrapper.querySelector('img');
                    gsap.timeline()
                        .to(outerWrapper, {
                            delay: .25,
                            scaleX: 1,

                            duration: .75,
                            ease: "sine.inOut"
                        })
                        .to(outerWrapper, {

                            duration: .5,
                            ease: "sine.inOut"
                        })
                        .to(innerWrapper, { xPercent: 0, duration: 1.5, delay: .1 }, "-=.5")
                        .to(image, { xPercent: 0, scale: 1, duration: 1.5, }, "-=1.5")
                }
            })
        })
        this.intitWrapper()

    }
    intitWrapper = () => {
        const directionsParam = [
            ['left', 100, 1.05, -100],
            ['right', -100, 1, 100]
        ]

        this.DOM.wrapper.forEach((wrapper) => {
            gsap.set(wrapper, { scaleX: 0, transformOrigin: 'left' })
        })


        this.DOM.images.forEach((img) => {
            this.DOM.innerWrapper.push(wrapElement(img, 'innerWrapper'))
        })
        gsap.set(this.DOM.images, { xPercent: 100, scale: 1.1, transformOrigin: 'left center' })
        gsap.set(this.DOM.innerWrapper, { xPercent: -100, transformOrigin: 'left center', overflow: 'hidden' })
        this.DOM.wrapper.forEach(wrp => {
            this.observer.observe(wrp)
        }
        )
    }
}

new EmergingImages();

